import React from 'react';
import styles from './FJBackButton.module.less';
import FJBackArrowIcon from '../../../assets/back-arrow.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import classNames from 'classnames';

interface FJBackButtonProps {
    onBack: () => void;
    className?: string;
}

const FJBackButton: React.FC<FJBackButtonProps> = ({ onBack, className }) => {
    return (
        <button className={classNames(styles.back_btn, className)} onClick={onBack}>
            <FJBackArrowIcon />
            <span>{FJLocalStore._('back')}</span>
        </button>
    );
}

export default FJBackButton;
